export default __webpack_public_path__ + "static/media/ea-img.59986d91.png";